export default "__VITE_ASSET__BFWT2_0F__"